import React, { useEffect, useState } from "react";
import DynamicTable from "../../components/DynamicTable";
import ImageModal from "../../modals/ImageModal";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../components/Loader";
import ErrorMessage from "../../components/ErrorMessage";
import EditModal from "../../modals/EditModal";
import { getAction, updateAction } from "../../store/actions/services";
import { DecodeUserRole, DecodeUsername } from "../../hooks/userData";
import { Box } from "@mui/material";

const ServicesBanner = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.services.data);
  const loading = useSelector((state) => state.services.loading);
  const error = useSelector((state) => state.services.error);
  const [showModal, setShowModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [showEditModal, setEditModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(false);
  const [selectedTable, setSelectedTable] = useState(false);
  const userRole = DecodeUserRole();
  const username = DecodeUsername();

  useEffect(() => {
    dispatch(getAction());
  }, [dispatch]);

  const filteredData = data?.staticPages?.map((service) => {
    const { createdAt, updatedAt, image, translations, ...rest } = service;

    const translationObject = translations?.reduce((acc, translation) => {
      acc[translation.fieldName] = translation.translatedValue;
      return acc;
    }, {});

    return { ...rest, ...translationObject };
  });

  return (
    <Box>
      {(userRole === "admin" || userRole === "superadmin") && (
        <>
          {loading ? (
            <Loader />
          ) : error ? (
            <ErrorMessage message={error} />
          ) : (
            <>
              <EditModal
                onClose={() => setEditModal(false)}
                showEditModal={showEditModal}
                table={selectedTable}
                action={updateAction}
                selectedRow={selectedRow}
                username={username}
                hasImage={false}
              />

              <ImageModal
                image={selectedImage}
                onClose={() => setShowModal(false)}
                showModal={showModal}
              />
              <DynamicTable
                data={filteredData}
                setSelectedImage={setSelectedImage}
                setShowModal={setShowModal}
                canCreate={false}
                canDelete={false}
                setEditModal={setEditModal}
                setSelectedRow={setSelectedRow}
                table={"Services Banner"}
                setSelectedTable={setSelectedTable}
                staticPage={true}
                getAction={getAction}
                hasLang={true}
              />
            </>
          )}
        </>
      )}
    </Box>
  );
};

export default ServicesBanner;
